import type { CSSProperties } from 'react';

const PREFERRED_HEIGHT = 280;
/** Only flip above when less than this much room remains below the trigger. */
const MIN_SPACE_BEFORE_FLIP = 160;
const GAP = 4;

/** Position a portaled dropdown beside its trigger; prefer below, shrink before flipping. */
export function getDropdownPosition(rect: DOMRect): CSSProperties {
  const spaceBelow = window.innerHeight - rect.bottom - GAP;
  const spaceAbove = rect.top - GAP;
  const openAbove = spaceBelow < MIN_SPACE_BEFORE_FLIP && spaceAbove > spaceBelow;
  const availableHeight = Math.min(PREFERRED_HEIGHT, openAbove ? spaceAbove : spaceBelow);

  return {
    position: 'fixed',
    left: rect.left,
    width: rect.width,
    top: openAbove ? rect.top - availableHeight - GAP : rect.bottom + GAP,
    maxHeight: Math.max(availableHeight, 80),
    zIndex: 9999,
  };
}

/** Portaled dropdown aligned to the trigger's right edge (for table row action menus). */
export function getDropdownPositionRightAligned(
  rect: DOMRect,
  minWidth = 200
): CSSProperties {
  const spaceBelow = window.innerHeight - rect.bottom - GAP;
  const spaceAbove = rect.top - GAP;
  const openAbove = spaceBelow < MIN_SPACE_BEFORE_FLIP && spaceAbove > spaceBelow;
  const availableHeight = Math.min(PREFERRED_HEIGHT, openAbove ? spaceAbove : spaceBelow);
  const width = Math.max(minWidth, rect.width);

  return {
    position: 'fixed',
    left: Math.max(GAP, rect.right - width),
    width,
    top: openAbove ? rect.top - availableHeight - GAP : rect.bottom + GAP,
    maxHeight: Math.max(availableHeight, 80),
    zIndex: 9999,
  };
}
